import { RootState } from '@/shared/store'

import { driversAdapter } from './driversAdapters'

export const driversSelectors = driversAdapter.getSelectors<RootState>(
  (state) => state.drivers,
)
